import { Dialog, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { useUserData } from "src/context/userContext";
import { useKeikkaLaskuData } from "src/context/KeikkaLaskuContext";
import { useKeikkaData } from "src/context/KeikkaDataContext";
import { isEmail } from "src/components/js/statics1";
import mailClass from "src/data/system/mailClass";
import SMSClass from "src/data/SMSClass";
import {
  kunPumppuToimittajaHyväksyyTilauksen,
  kunPumppuToimittajaVastaanottaaTilauksen,
  sendTilausvahvistus_exported,
} from "src/data/keikka/handleKeikka";

import StepButtons from "src/components/buttons/StepButtons/StepButtons";
import MyDivider from "src/components/layout/MyDivider";
import MySwitch from "src/components/MySwitch/MySwitch";
import { CloseIcon } from "src/components/icons/ActionIcons";
import KeikkaInfoBanner from "src/components/keikka/KeikkaInfoBanner/KeikkaInfoBanner";

export default function HandleKeikkaModal(props) {
  const { user, token, socket } = useUserData();
  const { keikkaLasku } = useKeikkaLaskuData();
  const { keikkaData, reloadKeikkaData, doSetKeikkaData: setKeikkaData } = useKeikkaData();

  const [switch_Ok, setSwitch_Ok] = useState(keikkaData.tila.keikkaTilaId === 3);
  const [isVastaanotettu, setIsVastaanotettu] = useState(keikkaData.tila.keikkaTilaId === 3);
  const [switch_email, setSwitch_email] = useState(false);
  const [switch_sms, setSwitch_sms] = useState(false);
  const [key, setKey] = useState(100);

  const hasEmail = isEmail(keikkaData.keikkaContactPerson.personEmail);

  useEffect(() => {
    const _isVastaanotettu = keikkaData.tila.keikkaTilaId === 3;
    setSwitch_Ok(_isVastaanotettu);
    setIsVastaanotettu(_isVastaanotettu);
    setSwitch_email(hasEmail && _isVastaanotettu);
    setSwitch_sms(_isVastaanotettu);
    setKey(key + 1);
  }, [props.open]);

  const handleClose = () => {
    props.closeModal();
  };

  const handleAcceptKlik = async (keikkaData) => {
    // Kun hyväksytään tai vastaanotetaan tilaus
    const personId = user.personId;

    if (switch_Ok) {
      await kunPumppuToimittajaHyväksyyTilauksen(keikkaData, personId, token, socket);
    } else {
      await kunPumppuToimittajaVastaanottaaTilauksen(keikkaData, personId, token, socket);
    }
    if (switch_email) {
      const thisMail = new mailClass(keikkaData);
      thisMail.emailToEmail = keikkaData.keikkaContactPerson.personEmail;
      sendTilausvahvistus_exported(thisMail, keikkaData, personId, token, socket);
    }
    if (switch_sms) {
      console.log("send sms");
      const sms = new SMSClass(keikkaData, personId, token);
      const SMSTxt =
        "BetoniOnline tilauksenne on hyväksytty:\n" +
        keikkaData.smsString +
        "\n\rterveisin: BetoniOnline";
      sms.sendSMS(keikkaData.keikkaContactPerson.personPhone, SMSTxt, socket);
    }
    // poista muokkaustila
    keikkaData.tila.muokkaustila = false;

    // päivitä keikkaData
    setKeikkaData(keikkaData);
    reloadKeikkaData(); // await?
    // sulje modal
    props.closeModal();
  };
  const handleCancelKlik = () => {
    setKeikkaData(keikkaData);
    props.closeModal();
  };

  const handleSwitchChange = (newValue) => setSwitch_Ok(newValue);
  const handleSwitchEmailChange = (newValue) => setSwitch_email(newValue);
  const handleSwitchSmsChange = (newValue) => setSwitch_sms(newValue);

  return (
    <>
      <Dialog
        open={props.open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullScreen={window.innerWidth < 600}>
        <DialogTitle id="alert-dialog-title">
          <div className="spaceBetween" style={{ gap: 12 }}>
            <div>
              <Typography variant="h6" color="primary">
                Vastaanota tai vahvista tilaus
              </Typography>
            </div>
            <div style={{ display: "flex", gap: 12 }}>
              <IconButton onClick={handleCancelKlik} aria-label="Sulje">
                <CloseIcon color="primary" />
              </IconButton>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <KeikkaInfoBanner
            keikkaData={keikkaData}
            setKeikkaData={setKeikkaData}
            keikkaLasku={keikkaLasku}
          />
          <MyDivider gutterBottom />
          <>
            <Grid container sx={{ width: "100%" }}>
              <Grid size={{ xs: 12 }}>
                <MySwitch
                  key={key * 1}
                  checked={switch_Ok || false}
                  onChange={handleSwitchChange}
                  name="switch_Ok"
                  disabled={isVastaanotettu}
                  rightSide="Vahvista tilaus"
                  leftSide="Vastaanota tilaus"
                  helpId="acceptAllKeikkaData"
                />
              </Grid>

              <Grid size={{ xs: 12 }}>
                <MySwitch
                  key={key * 2}
                  disabled
                  checked={switch_email || false}
                  onChange={handleSwitchEmailChange}
                  name="switch_sendEmail"
                  rightSide={
                    "Lähetä tilausvahvistus sähköpostitse (" +
                    (hasEmail
                      ? +keikkaData.keikkaContactPerson.personEmail
                      : "Ei sähköpostiosoitetta") +
                    ")"
                  }
                />
              </Grid>
              <Grid size={{ xs: 12 }}>
                {import.meta.env.ENABLE_SMS === "yes" && (
                  <MySwitch
                    key={key * 3}
                    checked={switch_sms || false}
                    onChange={handleSwitchSmsChange}
                    name="switch_sendSms"
                    rightSide={
                      "Lähetä tekstiviesti että tilaus hyväksytty (" +
                      keikkaData.keikkaContactPerson.personPhone +
                      ")"
                    }
                  />
                )}
              </Grid>
            </Grid>
            <MyDivider />
          </>
          <MyDivider gutterBottom />
          <Grid container sx={{ width: "100%" }}>
            <Grid size={{ xs: 4 }}>Tilamuutos:</Grid>
            <Grid size={{ xs: 8 }}>
              {keikkaData.tila.keikkaTilaSelite} -&gt;{" "}
              {switch_Ok ? "Toimitusvalmis" : "Käsittelyssä"}
            </Grid>
          </Grid>
          <StepButtons
            withPadding
            onCancelKlik={() => handleCancelKlik()}
            onAcceptKlik={() => handleAcceptKlik(keikkaData)}
            rightButtonDisabled={false}
            rightButtonText={switch_Ok ? "VAHVISTA TILAUS" : "VASTAANOTA TILAUS"}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
HandleKeikkaModal.propTypes = {
  closeModal: PropTypes.func,
  open: PropTypes.bool,
};
